export const ru = {
    corporate_tariff: 'Корпоративный тариф',
    tooltip_content: 'Тариф для Яндекса позволяет бронировать номера по указанной цене в течение года',
};
